import { render } from "./MaoVideoButton.vue?vue&type=template&id=ed222e4a&scoped=true"
import script from "./MaoVideoButton.vue?vue&type=script&lang=js"
export * from "./MaoVideoButton.vue?vue&type=script&lang=js"

import "./MaoVideoButton.vue?vue&type=style&index=0&id=ed222e4a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed222e4a"]])

export default __exports__